/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindMappingByTypeQueryResponse,
  FindMappingByTypePathParams,
  FindMappingByTypeQueryParams,
} from "../types/FindMappingByType.ts"

export const findMappingByTypeQueryKey = (
  type: FindMappingByTypePathParams["type"],
  params: FindMappingByTypeQueryParams
) =>
  [
    {
      url: "/v1/client-settings/find-mapping-by-type/:type",
      params: { type },
    },
    ...(params ? [params] : []),
  ] as const

export type FindMappingByTypeQueryKey = ReturnType<
  typeof findMappingByTypeQueryKey
>

/**
 * @summary Find mapping by type
 * {@link /v1/client-settings/find-mapping-by-type/:type}
 */
export async function findMappingByType(
  type: FindMappingByTypePathParams["type"],
  params: FindMappingByTypeQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindMappingByTypeQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/client-settings/find-mapping-by-type/${type}`,
    params,
    ...requestConfig,
  })
  return res
}

export function findMappingByTypeQueryOptions(
  type: FindMappingByTypePathParams["type"],
  params: FindMappingByTypeQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findMappingByTypeQueryKey(type, params)
  return queryOptions<
    ResponseConfig<FindMappingByTypeQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindMappingByTypeQueryResponse>,
    typeof queryKey
  >({
    enabled: !!(type && params),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findMappingByType(type, params, config)
    },
  })
}

/**
 * @summary Find mapping by type
 * {@link /v1/client-settings/find-mapping-by-type/:type}
 */
export function useFindMappingByType<
  TData = ResponseConfig<FindMappingByTypeQueryResponse>,
  TQueryData = ResponseConfig<FindMappingByTypeQueryResponse>,
  TQueryKey extends QueryKey = FindMappingByTypeQueryKey,
>(
  type: FindMappingByTypePathParams["type"],
  params: FindMappingByTypeQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindMappingByTypeQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? findMappingByTypeQueryKey(type, params)

  const query = useQuery(
    {
      ...findMappingByTypeQueryOptions(type, params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
